import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import AddTikTokIdentityForm from './AddTikTokIdentityForm'
import FormDrawerWrapper from '../../../../../features/components/FormDrawerWrapper'
import SkeletonSingleSectionForm from '../../../../../features/components/FormDrawerWrapper/Skeletons/SkeletonSingleSectionForm'

import useManageDrawer from '../../../../../hooks/formHooks/useManageDrawer'

import { clearTikTokIdentities, getTikTokIdentities } from '../../../../../modules/actions/tikTokConstants'
import { tikTokIdentitiesWasLoadedSelector } from '../../../../../modules/selectors/tikTokConstants'
import { selectedTikTokAdAccountSelector } from '../../../../../modules/selectors/adAccounts'

import { ACCESSIBLE_SOCIAL_PAGE_ADD_TIKTOK } from '../../../../../constants/forms'

const AddTikTokIdentity = () => {
  const dispatch = useDispatch()

  const { id: tikTokAdAccountId } = useSelector(selectedTikTokAdAccountSelector)
  const tikTokIdentitiesWasLoaded = useSelector(tikTokIdentitiesWasLoadedSelector)

  const { isFormOpen } = useManageDrawer({
    formName: ACCESSIBLE_SOCIAL_PAGE_ADD_TIKTOK
  })

  useEffect(() => {
    if (isFormOpen && !tikTokIdentitiesWasLoaded) {
      dispatch(getTikTokIdentities({ account: tikTokAdAccountId }))
    }
  }, [dispatch, isFormOpen, tikTokAdAccountId, tikTokIdentitiesWasLoaded])

  useEffect(
    () => () => {
      dispatch(clearTikTokIdentities())
    },
    [dispatch]
  )

  return (
    <FormDrawerWrapper
      formName={ACCESSIBLE_SOCIAL_PAGE_ADD_TIKTOK}
      openButtonText="Add a TikTok Identity"
      title="Add a TikTok Identity"
      isFormLoading={!tikTokIdentitiesWasLoaded}
      SkeletonFormComponent={SkeletonSingleSectionForm}
    >
      <AddTikTokIdentityForm />
    </FormDrawerWrapper>
  )
}

export default AddTikTokIdentity
